// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FU-z","inlineTitle":"GU-z","sponsoredAdsWrapper":"HU-z","marketplaceRecosWrapper":"IU-z"};